import { bankid } from "@wayke-se/ecom";
export default (data, callback) => {
    const request = bankid.newAuthRequest().withMethod(data.method).build();
    bankid
        .auth(request)
        .then((response) => {
        callback(response);
    })
        .catch(callback);
};
